/**
 * @generated SignedSource<<ae36fb65ad237fb31ef6a181746ed94d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TimeRange = {
  end?: string | null;
  start?: string | null;
};
export type GlobalDashboardPageDrawerQuery$variables = {
  evaluationName: string;
  timeRange: TimeRange;
};
export type GlobalDashboardPageDrawerQuery$data = {
  readonly projects: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly evaluationIssues: ReadonlyArray<{
          readonly actualValue: string;
          readonly affectedProjects: ReadonlyArray<string>;
          readonly affectedTracesCount: number;
          readonly affectedTracesPercentage: number;
          readonly avgValue: string;
          readonly confidenceLevel: number | null;
          readonly exampleTraceId: string;
          readonly expectedValue: string;
          readonly firstSeenTimestamp: string;
          readonly issueName: string;
          readonly lastSeenTimestamp: string;
          readonly mostAffectedSpan: string;
          readonly recommendation: string;
          readonly relatedIssueGroup: string;
          readonly rootCause: string;
          readonly severity: string;
        }>;
        readonly evaluationTraces: ReadonlyArray<{
          readonly affectedComponent: string;
          readonly evaluationScore: number | null;
          readonly issueName: string;
          readonly metricValue: string;
          readonly modelName: string | null;
          readonly projectId: string;
          readonly projectName: string;
          readonly spanId: string;
          readonly spanName: string;
          readonly status: string;
          readonly timestamp: string;
          readonly traceId: string;
        }>;
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
};
export type GlobalDashboardPageDrawerQuery = {
  response: GlobalDashboardPageDrawerQuery$data;
  variables: GlobalDashboardPageDrawerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "evaluationName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "timeRange"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "evaluationName",
    "variableName": "evaluationName"
  },
  {
    "kind": "Variable",
    "name": "timeRange",
    "variableName": "timeRange"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueName",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 100
      }
    ],
    "concreteType": "ProjectConnection",
    "kind": "LinkedField",
    "name": "projects",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProjectEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Project",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EvaluationIssue",
                "kind": "LinkedField",
                "name": "evaluationIssues",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "severity",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "confidenceLevel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "affectedTracesCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "affectedTracesPercentage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "affectedProjects",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mostAffectedSpan",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rootCause",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "avgValue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstSeenTimestamp",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastSeenTimestamp",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "exampleTraceId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expectedValue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualValue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recommendation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "relatedIssueGroup",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "EvaluationTrace",
                "kind": "LinkedField",
                "name": "evaluationTraces",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "traceId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "evaluationScore",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "affectedComponent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "spanName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "modelName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "metricValue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timestamp",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "spanId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "projects(first:100)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GlobalDashboardPageDrawerQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GlobalDashboardPageDrawerQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "1fc2f9d3d5a44d44258b89bd936b2d73",
    "id": null,
    "metadata": {},
    "name": "GlobalDashboardPageDrawerQuery",
    "operationKind": "query",
    "text": "query GlobalDashboardPageDrawerQuery(\n  $evaluationName: String!\n  $timeRange: TimeRange!\n) {\n  projects(first: 100) {\n    edges {\n      node {\n        id\n        name\n        evaluationIssues(evaluationName: $evaluationName, timeRange: $timeRange) {\n          issueName\n          severity\n          confidenceLevel\n          affectedTracesCount\n          affectedTracesPercentage\n          affectedProjects\n          mostAffectedSpan\n          rootCause\n          avgValue\n          firstSeenTimestamp\n          lastSeenTimestamp\n          exampleTraceId\n          expectedValue\n          actualValue\n          recommendation\n          relatedIssueGroup\n        }\n        evaluationTraces(evaluationName: $evaluationName, timeRange: $timeRange) {\n          traceId\n          projectName\n          status\n          evaluationScore\n          issueName\n          affectedComponent\n          spanName\n          modelName\n          metricValue\n          timestamp\n          projectId\n          spanId\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4569a7a54f9933a4ea4112b29b7c8017";

export default node;
